import { ComponentClass } from "react";
import styled from "@emotion/styled";
import {
    Bookmark16Icon,
    Captions24Icon,
    Chat24Icon,
    Notes24Icon,
    Poll24Icon,
    Quiz24Icon,
    Slide24Icon,
    Tag16Icon,
    Copy24Icon,
} from "@kaltura/ds-react-icons";
import { SearchResultType } from "@kaltura/mediaspace-shared-types";

/**
 * a function that takes an icon and returns it 16px*16px size
 * @param Icon
 */
const IconSizer = (Icon: ComponentClass) =>
    styled(Icon)(({ theme }) => ({
        width: theme.spacing(2),
        height: theme.spacing(2),
    }));

export const getIcon = (itemType: SearchResultType) => {
    let IconClass;
    switch (itemType) {
        case "tags":
            IconClass = IconSizer(Tag16Icon as unknown as ComponentClass);
            return <IconClass />;
        case "caption":
            IconClass = IconSizer(Captions24Icon as unknown as ComponentClass);
            return <IconClass />;
        case "slides":
            IconClass = IconSizer(Slide24Icon as unknown as ComponentClass);
            return <IconClass />;
        case "chapters":
            IconClass = IconSizer(Bookmark16Icon as unknown as ComponentClass);
            return <IconClass />;
        case "comments":
            IconClass = IconSizer(Chat24Icon as unknown as ComponentClass);
            return <IconClass />;
        case "quiz":
            IconClass = IconSizer(Quiz24Icon as unknown as ComponentClass);
            return <IconClass />;
        case "polls":
            IconClass = IconSizer(Poll24Icon as unknown as ComponentClass);
            return <IconClass />;
        case "metadata":
            IconClass = IconSizer(Notes24Icon as unknown as ComponentClass);
            return <IconClass />;
        case "ocr":
            IconClass = IconSizer(Copy24Icon as unknown as ComponentClass);
            return <IconClass />;
        default:
            console.log("search results unhandled data item", itemType);
            return <span />;
    }
};
